import React from "react";
import "./ProducerItem.scss";
import { EnvironmentFilled } from "@ant-design/icons";
import { Avatar, Card, Rate } from "antd";
import Helpers from "@utils/Helpers";
import { useNavigate } from "react-router-dom";

interface IProducerItem {
  data: any;
}

const ProducerItem: React.FC<IProducerItem> = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div className="ProducerItem">
      <Card
        hoverable
        className="store-card"
        onClick={() => navigate(`/producer/detail?producerId=${data.user_id}`)}
      >
        <div className="store-image-wrap">
          <div className="store-background">
            <img
              src={
                data.farm_info.banner == null
                  ? Helpers.getImageFrontPage("backstore3")
                  : data.farm_info.banner
              }
              alt="store-background"
            />
          </div>
          <div className="store-avatar">
            <div className="img-fluid">
              {data.farm_info.avatar == null || data.farm_info.avatar === "" ? (
                <Avatar className="farm-avatar-default" size={80}>
                  {data.farm_info.farm_name
                    ? data.farm_info.farm_name[0].toUpperCase()
                    : "F"}
                </Avatar>
              ) : (
                <Avatar src={data.farm_info.avatar} size={80} />
              )}
            </div>
          </div>
          <div className="store-type">Farm</div>
        </div>
        <div className="store-title">{data?.farm_info?.farm_name}</div>
        <div className="store-rating">
          <div className="store-rating-star">
            <Rate disabled defaultValue={4} />
          </div>
          <span className="store-rating-value">90 reviews</span>
        </div>
        <div className="store-location">
          <EnvironmentFilled />{" "}
          <span>
            {data.farm_info.city == null ? "" : data.farm_info.city + ","}{" "}
            {data.farm_info.province}
          </span>
        </div>
      </Card>
    </div>
  );
};

export default ProducerItem;
